import { Card } from "../../../components/card/card.jsx";
import { DataTable } from "../../../components/table/table.tsx";
import { useEffect, useState } from "react";
import { apiUrl } from "../../../config/config.js";
import Swal from "sweetalert2";
import UserDetailModal from "./userDetail.js";
import moment from "moment";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});



function Users() {
	const [users, setUsers] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	//Para ver el detalle de una categoria
	const [user, setUser] = useState(null);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		fetchUsers();
	}, []);

	const fetchUsers = async () => {
		try {
			const response = await fetch(`${apiUrl}/users`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				}
			});
			const responseUsers = await response.json()
			if (responseUsers.ok) {
				setUsers(responseUsers.data || []);
			}

		} catch (err) {
			console.error('Error cargando usuarios', err);
		} finally {
			setIsLoading(false);
		}
	};

	if (isLoading) {
		return (
			<div className="text-center">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Cargando...</span>
				</div>
			</div>
		);
	}

	const openModal = async (userId) => {
		console.log("Opening modal for user ID:", userId);
		try {
			const response = await fetch(`${apiUrl}/users/${userId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				}
			});
			const responseUser = await response.json();
			if (responseUser.ok) {
				const { data } = responseUser;
				setUser(data || null);
				setShowModal(true);
			} else {
				Toast.fire({
					icon: "error",
					title: "Error buscando el usuario seleccionado",
				});
			}
		} catch (error) {
			console.error("Error buscando el usuario seleccionado:", error);
			Toast.fire({
				icon: "error",
				title: "Error buscando el usuario seleccionado",
			});
		}
	}

	const openModalForCreate = () => {
		setUser(null);
		setShowModal(true);
	}

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Usuarios</h1>
				</div>
				<div className="ms-auto">
					<button onClick={() => openModalForCreate()} className="btn btn-outline-theme">
						<i className="fa fa-plus-circle fa-fw me-1"></i> Agregar usuario
					</button>
				</div>
			</div>
			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<DataTable
							data={users}
							hiddenFields={['id']}
							columns={[
								{ key: 'email', label: 'Correo electrónico' },
								{ key: 'completeName', label: 'Nombre completo' },
								{/*
									key: 'phone', label: 'Teléfono',
									render: (value) => value ?? 'N/A'
								*/},
								{
									key: 'role', label: 'Rol',
									render: (value) => value.nameRole
								},
								//{ key: 'createdBy', label: 'Creado por' },
								{
									key: 'createdAt', label: 'Fecha creación',
									render: (value) => moment.utc(value).local().format("DD/MM/YYYY hh:mm A")
								},
								{
									key: 'active', label: 'Estado',
									render: (value) => {
										switch (value) {
											case 1:
												return (
													<span className="badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Activo
													</span>
												);
											case 0:
												return (
													<span className="badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Inactivo
													</span>
												);
											case -1:
											default:
												return (
													<span className="badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Pendiente
													</span>
												);
										}
									}
								},
								{
									key: 'licenseStatus',
									label: 'Licencia',
									render: (value) => {
										if (!value) {
											return (
												<span className="badge border border-secondary text-secondary px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
													<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
													N/A
												</span>
											);
										}

										switch (value) {
											case 'PENDING_PAYMENT':
												return (
													<span className="badge border border-warning text-warning px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Pendiente de pago
													</span>
												);
											case 'ACTIVE':
												return (
													<span className="badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Activa
													</span>
												);
											case 'EXPIRED':
												return (
													<span className="badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Expirada
													</span>
												);
											case 'SUSPENDED':
												return (
													<span className="badge border border-secondary text-secondary px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Suspendida
													</span>
												);
											case 'CANCELLED':
												return (
													<span className="badge border border-dark text-dark px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														Cancelada
													</span>
												);
											default:
												return (
													<span className="badge border border-secondary text-secondary px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center">
														<i className="fa fa-circle fs-9px fa-fw me-5px"></i>
														N/A
													</span>
												);
										}
									}
								},
							]}
							onEdit={async (row) => await openModal(row.id)} />
					</div>
				</div>
			</Card>
			<UserDetailModal
				show={showModal}
				userSelected={user}
				fectchData={fetchUsers}
				onClose={() => {
					setUser(null);
					setShowModal(false);
				}}
			/>
		</div>
	);
}
export default Users;
